/* eslint-disable import/extensions */
import { Color } from '@material-ui/lab';
import {
  SAVE_USER,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  AUTHENTICATE,
  UNAUTHENTICATE,
  REDIRECTED,
  SAVE_COMPANY_SUMMARY,
  SAVE_COMPANY_NEWS,
  SAVE_COMPANY_NEWS_PAGE,
  HIDE_CINTEL,
  SHOW_INV_MODAL,
  HIDE_INV_MODAL,
  SHOW_PARTICIPANT_ERROR_MODAL,
  HIDE_PARTICIPANT_ERROR_MODAL,
  SAVE_PARTICIPANT_CREDS,
  IS_NOT_MODERATOR,
  CLOSE_CINTEL,
  OPEN_CINTEL,
  OPEN_ISSUE_POPUP,
  CLOSE_ISSUE_POPUP,
  STOP_RECORDING,
  UPDATE_CINTEL,
  SHOW_STOP_REC_MODAL,
  HIDE_STOP_REC_MODAL,
  SAVE_ROOM_DETAILS,
  EMBED_TYPE,
  SAVE_CUSTOMER,
  START_RECORDING,
  SAVE_VIDEO_DOMAIN,
  SAVE_ROOM_META,
  CLICKED_START_RECORDING,
} from '../action-types';

interface ISummaryAPIResponse {
  about: string;
  domain: string;
  founded_year: string;
  funding: string;
  industries: string[];
  location: string;
  org_name: string;
  size: string;
  website: string;
  customer: {
    [key: string]: any;
  };
}

interface INewsAPI {
  article_date: string;
  article_link: string;
  article_text: string;
  headline: string;
  img_link: string;
}

interface CommonState {
  user: {
    id: number;
    first_name: string;
    middle_name: string | null;
    last_name: string;
    avatar_url: string | null;
    email: string;
    phone_ext: string | null;
    phone: string | null;
    last_signedin_at: string;
    status: string;
    created_at: string;
    updated_at: string;
    workspace_id: any;
    workspace_preference_id: any;
    organisation: {
      id: number;
      name: string;
      preferences: {
        domain: string;
        meet_primary_color: string;
        meet_logo: {
          data: string;
          file_name: string;
        };
        meet_custom: boolean;
      } | null;
    };
  };
  isLoggedIn: boolean;
  isAuthenticated: boolean;
  snackbar: {
    visible: boolean;
    message: string | undefined;
    type: Color | undefined;
  };
  redirectedFromApp: boolean;
  companySummary: ISummaryAPIResponse | {} | any;
  companyNews: INewsAPI[] | [];
  newsPage: number;
  totalPages: number;
  hideCintel: boolean;
  invModal: {
    showInvModal: boolean;
  };
  participantLimitModal: {
    showParticipantLimitModal: boolean;
  };
  participantDisplayName: string;
  participantPasscode: string;
  cintelPanelOpen: boolean;
  issuePopupOpen: boolean;
  isOwner: boolean;
  isMeetingRecorded: boolean;
  updateCintel: boolean;
  stopRecModal: {
    visible: boolean;
  };
  roomDetails: {
    id: number;
    room_name: string;
    user: {
      email: string;
      first_name: string;
      last_name: string | null;
      organisation_id: number;
    };
    organisation: {
      id: number;
      name: string;
      logo: string;
      preferences: {
        domain: string;
        meet_primary_color: string;
        meet_logo: {
          data: string;
          file_name: string;
        };
        meet_custom: boolean;
      } | null;
      is_recording_enabled: boolean;
    };
    customer: {
      name: string;
      workspace_id: number;
    };
    room_type: string;
  } | null;
  embedType: string;
  customer: Object | null;
  videoDomain: {
    domain: string;
    loaded: boolean;
  };
  orgName: string;
  roomMeta: {
    customer_id: number;
    latest_conversation_id: number;
    organisation_id: number;
    schedule_id: number;
    user_id: number;
    workspace_id: number;
  } | null;
  clickedStartRecording: boolean;
}

interface IAction {
  type: string;
  payload: any;
}

const initialState = {
  user: {
    id: 0,
    first_name: '',
    middle_name: '',
    last_name: '',
    avatar_url: '',
    email: '',
    phone_ext: '',
    phone: '',
    last_signedin_at: '',
    status: '',
    created_at: '',
    updated_at: '',
    workspace_id: null,
    workspace_preference_id: null,
    organisation: {
      id: 0,
      name: '',
      feature_flags: {
        realtime_widget_enabled: false,
        prospect_score_enabled: false,
      },
      preferences: null,
      created_at: '',
    },
  },
  isLoggedIn: false,
  isAuthenticated: false,
  snackbar: {
    visible: false,
    message: undefined,
    type: undefined,
  },
  redirectedFromApp: false,
  companySummary: {},
  companyNews: [],
  newsPage: 1,
  totalPages: 1,
  hideCintel: false,
  hideIssuePopup: false,
  invModal: {
    showInvModal: false,
  },
  participantLimitModal: {
    showParticipantLimitModal: false,
  },
  participantDisplayName: '',
  participantPasscode: '',
  cintelPanelOpen: true,
  issuePopupOpen: false,
  isOwner: false,
  isMeetingRecorded: false,
  updateCintel: false,

  stopRecModal: {
    visible: false,
  },
  roomDetails: null,
  embedType: '',
  customer: null,
  videoDomain: {
    domain: '',
    loaded: false,
  },
  orgName: '',
  roomMeta: null,
  clickedStartRecording: false,
};

const CommonReducer = (
  state: CommonState = initialState,
  action: IAction,
): CommonState => {
  const { type = '', payload = {} } = action;
  switch (type) {
    case SAVE_USER:
      return {
        ...state,
        isLoggedIn: true,
        user: { ...state.user, ...payload },
      };
    case IS_NOT_MODERATOR:
      return {
        ...state,
        isLoggedIn: false,
        user: { ...state.user, ...payload },
      };

    case SHOW_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state.snackbar,
          ...payload,
          visible: true,
        },
      };
    case HIDE_SNACKBAR:
      return {
        ...state,
        snackbar: {
          ...state,
          ...payload,
          visible: false,
        },
      };
    case AUTHENTICATE:
      return {
        ...state,
        isAuthenticated: true,
        isOwner: payload?.isOwner,
      };
    case UNAUTHENTICATE:
      return {
        ...state,
        isAuthenticated: false,
        isOwner: false,
      };
    case REDIRECTED:
      return {
        ...state,
        redirectedFromApp: true,
      };
    case SAVE_COMPANY_SUMMARY:
      return {
        ...state,
        companySummary: payload,
      };
    case SAVE_COMPANY_NEWS:
      return {
        ...state,
        companyNews: payload?.news,
        totalPages: payload?.totalPages,
      };
    case SAVE_COMPANY_NEWS_PAGE:
      return {
        ...state,
        newsPage: payload,
      };
    case HIDE_CINTEL:
      return {
        ...state,
        hideCintel: true,
      };

    case SHOW_INV_MODAL:
      return {
        ...state,
        invModal: { ...state.invModal, ...payload },
      };
    case HIDE_INV_MODAL:
      return {
        ...state,
        invModal: initialState.invModal,
      };
    case SHOW_PARTICIPANT_ERROR_MODAL:
      return {
        ...state,
        participantLimitModal: { ...state, ...payload },
      };
    case HIDE_PARTICIPANT_ERROR_MODAL:
      return {
        ...state,
        participantLimitModal: initialState.participantLimitModal,
      };
    case SAVE_PARTICIPANT_CREDS:
      return {
        ...state,
        participantDisplayName: payload?.displayName,
        participantPasscode: payload?.passcode,
        orgName: payload?.orgName || '',
      };
    case OPEN_CINTEL:
      return {
        ...state,
        cintelPanelOpen: true,
      };
    case CLOSE_CINTEL:
      return {
        ...state,
        cintelPanelOpen: false,
      };
    case OPEN_ISSUE_POPUP:
      return {
        ...state,
        issuePopupOpen: true,
      };
    case CLOSE_ISSUE_POPUP:
      return {
        ...state,
        issuePopupOpen: false,
      };
    case STOP_RECORDING:
      return {
        ...state,
        isMeetingRecorded: false,
      };
    case START_RECORDING:
      return {
        ...state,
        isMeetingRecorded: true,
      };
    case UPDATE_CINTEL:
      return {
        ...state,
        updateCintel: !state.updateCintel,
      };
    case SHOW_STOP_REC_MODAL:
      return {
        ...state,
        stopRecModal: { ...state.stopRecModal, visible: true },
      };
    case HIDE_STOP_REC_MODAL:
      return {
        ...state,
        stopRecModal: { ...state.stopRecModal, visible: false },
      };
    case SAVE_ROOM_DETAILS:
      return {
        ...state,
        roomDetails: { ...state.roomDetails, ...payload },
      };
    case EMBED_TYPE:
      return {
        ...state,
        embedType: payload,
      };
    case SAVE_CUSTOMER:
      return {
        ...state,
        customer: payload,
      };
    case SAVE_VIDEO_DOMAIN:
      return {
        ...state,
        videoDomain: payload,
      };
    case SAVE_ROOM_META:
      return {
        ...state,
        roomMeta: payload,
      };
    case CLICKED_START_RECORDING:
      return {
        ...state,
        clickedStartRecording: payload,
      };
    default:
      return state;
  }
};

export default CommonReducer;
